import { Controller } from "@hotwired/stimulus"

const SELECTED_CLASSES = ["bg-gray-900", "text-white"]
const UNSELECTED_CLASSES = ["text-gray-500"]

// Switches the pricing table between monthly and annual prices.
//
// Both versions are rendered server-side and each one carries the intervals it
// belongs to in data-show-for, so a plan sold on a single interval keeps its
// own price and checkout link visible whatever the visitor picks.
export default class extends Controller {
  static targets = ["option", "toggleable"]
  static values = { interval: String }

  select(event) {
    this.intervalValue = event.currentTarget.dataset.interval
  }

  intervalValueChanged(interval) {
    this.optionTargets.forEach(option => {
      const selected = option.dataset.interval === interval
      SELECTED_CLASSES.forEach(name => option.classList.toggle(name, selected))
      UNSELECTED_CLASSES.forEach(name => option.classList.toggle(name, !selected))
      option.setAttribute("aria-pressed", selected)
    })

    this.toggleableTargets.forEach(el => {
      el.hidden = !el.dataset.showFor.split(" ").includes(interval)
    })
  }
}
